module.exports = require('../dist/selectors/small-medium-business-loans');
